import React from "react";
import { AiOutlineApi } from "react-icons/ai";

const PaEmptyState = ({
  title = "Coming soon",
  message = "API ready",
  description,
  action = null,
  icon = null,
}) => {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-indigo-50 text-indigo-600">
        {icon || <AiOutlineApi className="h-7 w-7" aria-hidden="true" />}
      </div>
      <h2 className="mt-4 text-lg font-semibold text-gray-900">{title}</h2>
      <p className="mt-2 text-sm font-medium text-indigo-600">{message}</p>
      {description ? (
        <p className="mt-2 max-w-md text-sm text-gray-500">{description}</p>
      ) : null}
      {action ? <div className="mt-6">{action}</div> : null}
    </div>
  );
};

export default PaEmptyState;
